import React from 'react';
import './StartScreen.scss';

interface StartScreenProps {
  onStart: () => void;
}

const StartScreen: React.FC<StartScreenProps> = ({ onStart }) => {
  return (
    <div className="start-screen">
      <img
        src={`${process.env.PUBLIC_URL}/images/start/base_background.png`}
        alt="Holiday background"
        className="start-screen__bg"
      />
      <div
        className="start-screen__box"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/start/background_box.png)` }}
      >
        <div className="start-screen__wrapper">
          <h1 className="start-screen__title">Holiday</h1>
          <h2 className="start-screen__subtitle">SCAVENGER HUNT</h2>
          <p className="start-screen__description">Find All The Items Listed</p>
          <button className="start-screen__button" onClick={onStart}>
            START THE GAME
          </button>
        </div>
      </div>
    </div>
  );
};

export default StartScreen;
